import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({ title, description, ogTitle, ogDescription }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SEOHelmet;
